import {DimensionedQty} from "../../../../api/Hardware";
import {useMemo, useState} from "react";
import {Alert, Button, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import WarningIcon from "@mui/icons-material/Warning";

export function ItemCalcErrors(props: {
    value: DimensionedQty;
}) {
    const errors = useMemo(() => {
        if(!props.value) return [];

        const out: string[] = [];

        props.value.forEach(v => {
            if(!v.openingDetail) return;

            v.openingDetail.forEach(op => {
                if(op.error) {
                    out.push(op.error);
                }
            });
        });

        return out;
    }, [props.value]);

    const [show, setShow] = useState(false);

    if(errors.length === 0) return null;

    return (
        <>
            <IconButton size="small" style={{
                fontSize: "1rem",
            }} onClick={(e) => setShow(true)}>
                <WarningIcon color="error" fontSize="inherit" />
            </IconButton>

            {show && <Dialog2 open onClose={() => setShow(false)}>
                <DialogTitle>Calculation Errors</DialogTitle>
                <DialogContent>
                    <Alert severity="error">
                        {errors.map((error, i) => (
                            <div key={i}>{error}</div>
                        ))}
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShow(false)}>Close</Button>
                </DialogActions>
            </Dialog2>}
        </>
    )
}